// @flow
export type SetDataAction = {type: "RESERVATION_DATA_SET", secret: string, reservation: Object, forward: boolean};
export type SetMembershipAutofillAction = {type: "RESERVATION_MEMBERSHIP_AUTOFILL_SET", membershipAutofill: Object};
export type CreateAction = {type: "RESERVATION_CREATED"};
export type TickAction = {type: "TICK"};
export type TickSetAction = {type: "TICK_SET", interval: number};
export type TickClearAction = {type: "TICK_CLEAR"};
export type ClearAction = {type: "RESERVATION_CLEARED", forward: boolean};
export type AddListingAction = {type: "ADD_LISTING", listing: Object}
export type SetDeliveryMethod = {type: "DELIVERY_METHOD_SET", selectedDelivery: Object}
export type CompletedAction = {type: "RESERVATION_COMPLETED"}
export type LoadingAction = {type: "RESERVATION_LOADING", val: boolean}
export type ExtendTimeRemainingAction = {type: "EXTEND_TIME"};

export type Action = SetDataAction | SetMembershipAutofillAction | TickAction | TickSetAction | ClearAction
  | TickClearAction | AddListingAction | SetDeliveryMethod | CompletedAction | LoadingAction
  | ExtendTimeRemainingAction;

import { getTopWindow } from '../helpers/window'

type SetLeapOptInAction = {+type: "SET_LEAP_OPT_IN", +opt_in: boolean};

type State = {
    +secret: string,
    +token: string,
    time_remaining: number,
    +leapOptIn: boolean,
    tickInterval: number,
    listings: Array<Object>,
    purchaseUser: number, // admin user to record purchases as
    allow_extend_time: boolean,
    extend_seconds: number,
    time_remaining_extended: boolean,
};

let initialState = {
    secret: "",
    token: "",
    time_remaining: 0,
    tickInterval: 0,
    listings: [],
    purchaseUser: 0,
    leapOptIn: false,
    time_remaining_extended: false,
    allow_extend_time: true,
    extend_seconds: 600,
    mappedListingIds: [],
};

/** Reducer for reservation actions */
export function reservation(state: State = initialState, action:Action): State {
    if(action.type === "RESERVATION_DATA_SET") {
        let newState = {...state, secret: action.secret, token: action.reservation.id, ...action.reservation.attributes};
        // card types can come across as an empty array, but it should always be an object
        if(Array.isArray(newState.cardTypes)) {
            newState.cardTypes = {};
        }

        return newState;
    } else if (action.type === "RESERVATION_MEMBERSHIP_AUTOFILL_SET") {
        return {
            ...state,
            membership_autofill: action.membershipAutofill,
        };
    } else if(action.type === "TICK") {
        state.time_remaining = Math.max(0, state.time_remaining - 1);
        return state;
    } else if(action.type === "TICK_SET") {
        let newState = {...state, tickInterval: action.interval};
        return newState;
    } else if(action.type === "TICK_CLEAR") {
        getTopWindow().clearInterval(state.tickInterval);
        let newState = {...state, tickInterval: 0};
        return newState;
    } else if(action.type === "RESERVATION_CLEARED") {
        getTopWindow().clearInterval(state.tickInterval);
        let user = state.purchaseUser;
        return {...initialState, purchaseUser: user};
    } else if(action.type === "RESERVATION_COMPLETED") {
        getTopWindow().clearInterval(state.tickInterval);
        let user = state.purchaseUser;
        return { ...state, purchaseUser: user};
    } else if (action.type == "SET_LEAP_OPT_IN") {
        let newState = {...state};
        newState.leapOptIn = action.opt_in;
        return newState;
    } else if(action.type === "ADD_LISTING") {
        let newState = {...state};
        let found = false;
        for(let i = 0; i < newState.listings.length; i++) {
            if(newState.listings[i].event.event_id === action.listing.event.event_id) {
                found = true;
            }
        }

        if(!found) {
            newState.listings.push(action.listing);
        }

        return newState;
    } else if(action.type === "DELIVERY_METHOD_SET") {
        let newState = {...state};
        newState.selected_delivery_option = action.selectedDelivery.id;
        return newState;
    } else if(action.type === "SET_PURCHASE_USER") {
        let newState = {...state};
        newState.purchaseUser = action.id;
        return newState;
    } else if (action.type === "SET_TOTAL_RESERVATION_DONATION") {
        return { ...state, total_donation: action.value };
    } else if(action.type === "EXTEND_TIME") {
        let newState = {
          ...state,
          time_remaining: state.time_remaining + state.extend_seconds,
          time_remaining_timestamp: state.time_remaining_timestamp + state.extend_seconds,
          time_remaining_extended: true
        };
        return newState;
    } else if (action.type === "RESERVATION_SET_MAPPED_LISTING_IDS") {
        const newState = {...state};
        if (Array.isArray(action.ids)) {
            newState.mappedListingIds = action.ids.map(id => +id);
        }
        return newState;
    } else {
        return state;
    }
}
